import { createDynamicSlice } from ".";
import { fetchDashboardThunk } from "../thunks/dashboardThunk";

export const dashboardSlice = createDynamicSlice({
  name: "dashboard",
  thunk: fetchDashboardThunk,
  listMode: true,
  resetActionName: "resetDashboard",
});

export const dashboardReducer = dashboardSlice.reducer;
export const { resetDashboard } = dashboardSlice.actions;
